import { render } from "./Snackbar.vue?vue&type=template&id=4e58c7e0&scoped=true"
import script from "./Snackbar.vue?vue&type=script&lang=js"
export * from "./Snackbar.vue?vue&type=script&lang=js"

import "./Snackbar.vue?vue&type=style&index=0&id=4e58c7e0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4e58c7e0"

export default script